import {
  BalanceDto,
  CryptoDepositInfoDto,
  FiatDepositInstructionDto,
  OrderDto,
  PairDto,
} from '@api/client';

export interface PairPrice {
  name: string;
  bestBuy: number;
  bestSell: number;
}

export interface PairViewModel extends PairDto {
  price?: PairPrice;
  baseAsset: string;
  quoteAsset: string;
}

export interface BalanceViewModel extends BalanceDto {
  available: number;
  isEquityLimiting: boolean;
  scale: number | undefined;
}

export type ReportType = 'transfers' | 'orders' | 'balances' | 'all';

export interface OrderViewModel extends OrderDto {
  requestedQty: number;
  requestedAsset: string;
}

export interface PendingDownloads {
  [fileId: string]: {
    fileName: string;
  };
}

export interface WSError {
  message: string;
  showRefreshPage: boolean;
}

export enum ReportFileFormat {
  CSV = 'CSV',
  PDF = 'PDF',
}

export type { CryptoDepositInfoDto, FiatDepositInstructionDto };
